export default {
  // list
  'base_currency.query.currencyCode': 'currencyCode',
  'base_currency.query.currencyCode.placeholder': 'Enter currencyCode',
  'base_currency.query.currencyName': 'currencyName',
  'base_currency.query.currencyName.placeholder': 'Enter currencyName',
  'base_currency.column.currencyCode': 'currencyCode',
  'base_currency.column.currencyName': 'currencyName',
  'base_currency.column.currencySymbol': 'currencySymbol',
  'base_currency.column.currencyUnit': 'currencyUnit',
  'base_currency.column.defaultFlag': 'defaultFlag',
  'base_currency.column.createBy': 'createBy',
  'base_currency.column.updateBy': 'updateBy',
  'base_currency.column.createTime': 'createTime',
  'base_currency.column.updateTime': 'updateTime',
  'base_currency.column.dataSource': 'dataSource',
  'base_currency.column.remark': 'remark',
  'base_currency.column.status': 'status',
  // edit
  'base_currency.edit.title': 'Edit BaseCurrency',
  'base_currency.add.title': 'Add BaseCurrency',
  'base_currency.edit.success': 'Edit Successful',
  'base_currency.add.success': 'Add Successful',
  'base_currency.form.currencyCode.required': 'currencyCode cannot be null',
  'base_currency.form.currencyName.required': 'currencyName cannot be null',
  'base_currency.form.currencySymbol.required': 'currencySymbol cannot be null',
  'base_currency.form.currencyUnit.required': 'currencyUnit cannot be null',
  'base_currency.form.defaultFlag.required': 'defaultFlag cannot be null',
  'base_currency.form.currencyCode': 'currencyCode',
  'base_currency.form.currencyCode.placeholder': 'Enter currencyCode',
  'base_currency.form.currencyName': 'currencyName',
  'base_currency.form.currencyName.placeholder': 'Enter currencyName',
  'base_currency.form.currencySymbol': 'currencySymbol',
  'base_currency.form.currencySymbol.placeholder': 'Enter currencySymbol',
  'base_currency.form.currencyUnit': 'currencyUnit',
  'base_currency.form.currencyUnit.placeholder': 'Enter currencyUnit',
  'base_currency.form.defaultFlag': 'defaultFlag',
  'base_currency.form.defaultFlag.placeholder': 'Enter defaultFlag',
}
